module.exports = __webpack_public_path__ + "img/ipo.2.d7829731.jpg";